<template>
  <div class="row presentation">
    <div class="small-12 medium-7 large-8 columns designacao_servico_text">
      <div class="content" v-html="textoDescritivo"></div>
    </div>
    <div class="small-12 medium-5 large-4 columns dgs">
      <h2 class="servico_nota">{{ $t('apresentacao.horariosecontactos') }}</h2>
      <ul class="dados_gerais_servico">
        <li>
          <h1>{{ $t('apresentacao.horario') }}</h1>
        </li>
        <li>
          <p v-html="horario"></p>
        </li>
        <li>
          <h1>{{ $t('apresentacao.email') }}</h1>
        </li>
        <li><a :href="`mailto:${email}`">{{ email }}</a></li>
        <li>
          <h1>{{ $t('apresentacao.telefone') }}</h1>
        </li>
        <li>
          <p>{{ telefone }}</p>
        </li>
        <li>
          <h1>{{ $t('apresentacao.morada') }}</h1>
        </li>
        <li>
          <p v-html="morada"></p>
        </li>
      </ul>
    </div>
  </div>
  <composicao />
</template>

<script setup>
import axios from '@/axios';
import { ref } from 'vue';
import composicao from '@/components/composicao.vue';
import { i18n } from "@/main";

const textoDescritivo = ref("")
const email = ref("")
const telefone = ref("")
const morada = ref("")
const horario = ref("")

const getInfo = () => {
  axios.get(`/servico/${import.meta.env.VITE_UID}?idioma=${i18n.global.locale}`).
    then(resp => {
      const { data } = resp;
      textoDescritivo.value = data.textodescritivo;
      email.value = data.email;
      telefone.value = data.telefone;
      morada.value = data.morada;
      horario.value = data.horario;
    }).catch(error => console.log(error))
}

getInfo();

</script>

<style scoped>
.dgs {
  padding-right: 0;
  padding-left: 0;
  position: relative;
}

.designacao_servico_text {
  font-family: 'PT Sans';
  color: #656565;
  line-height: 2.1;
  padding-left: 0px;
}

.designacao_servico_text ul li {
  margin-left: 20px;
}

.dados_gerais_servico {
  border: 1px solid #489ad4;
  padding: 40px;
  padding-left: 30px;
  position: relative;
  margin-left: 0;
}

.servico_nota {
  background-color: #79b2dc;
  display: inline-block;
  padding-right: 10px;
  padding-left: 12px;
  padding-bottom: 3px;
  padding-top: 3px;
  position: absolute;
  top: 0;
  right: 0;
  font-size: 12px;
  text-transform: uppercase;
}

.dgs h2 {
  font-family: "Montserrat";
  line-height: 1.4;
  color: white;
}

.dados_gerais_servico p,
.dados_gerais_servico a {
  font-family: 'PT Sans';
  color: #656565;
  line-height: 1.4;
  margin-bottom: 1rem;
  display: block;
}

.dados_gerais_servico li {
  list-style: none;
  padding: 0;
  margin: 0;
}

.dados_gerais_servico h1 {
  font-family: "Montserrat Semibold";
  color: #535d61;
  font-size: 15px;
  margin-bottom: 4px;
}

@media (max-width: 1024px) and (min-width: 768px) {
  .designacao_servico_text {
    line-height: 2;
    font-size: 15px;
  }

  .dados_gerais_servico p {
    line-height: 1.4 !important;
    line-height: 2;
    font-size: 15px;
  }

  .dados_gerais_servico h1 {
    margin-bottom: 0px;
    font-size: 15px;
  }

  .dados_gerais_servico h2 {
    font-size: 11px;
  }

  .dados_gerais_servico {
    padding: 35px 25px 5px;
  }

}

@media (max-width: 767px) {
  .dados_gerais_servico {
    border-bottom: transparent;
    padding: 20px 0px 10px;
    border-left: 2px solid transparent;
    border-right: 2px solid transparent;
    position: relative;
  }

  .dados_gerais_servico li:nth-of-type(2n) {
    margin-bottom: 1rem;
  }

  .designacao_servico_text {
    padding-bottom: 0px;
    padding-right: 0px;
    padding-left: 0px;
    font-size: 14px;
    line-height: 1.9;
  }

  .dados_gerais_servico h2 {
    display: none;
  }

  .servico_nota {
    font-size: 10px;
  }

  .dados_gerais_servico h1 {
    font-size: 14px;
    margin-bottom: 0px;
  }

  .dados_gerais_servico {
    font-size: 14px;
    line-height: 1.4;
    margin-bottom: -6px;
  }
}



.content p,
.content li,
.content :deep(p),
.content :deep(li) {
  font-family: 'PT Sans';
  color: #656565;
  line-height: 2.1;
}

.content p ul,
.content :deep(p ul) {
  margin: 10px 0;
  margin-top: 20px;
}

.content p ul li:not(:last-of-type),
.content p ul li:not(:first-of-type),
.content :deep(p ul li:not(:last-of-type)),
.content :deep(p ul li:not(:first-of-type)) {
  margin-bottom: 20px;
}

@media (max-width: 767px) {
  .content {
    margin-bottom: 1rem;
  }

  .servico_nota {
    display: none;
  }

}
</style>